const getTypeBall = (pokemonType) => {
    // Si pokemonType est une chaîne JSON, on la parse
    let types = pokemonType;
    try {
        if (typeof pokemonType === 'string') {
            types = JSON.parse(pokemonType);
        }
        // On utilise le premier type pour la couleur
        const primaryType = Array.isArray(types) ? types[0] : types;

        switch (primaryType) {
            case 'Grass':
                return 'rgb(55, 178, 96)';  // Vert
            case 'Water':
                return 'rgb(46, 107, 191)';  // Bleu
            case 'Psychic':
                return 'rgb(176, 64, 214)';  // Violet
            case 'Fire':
                return 'rgb(194, 112, 70)';  // Orange rouge
            case 'Bug':
                return 'rgb(210, 255, 106)';  // Vert jaune
            case 'Normal':
                return 'rgba(222, 222, 222)';  // Blanc
            case 'Ground':
                return 'rgb(111, 67, 36)';  // Marron
            case 'Flying':
                return 'rgb(225, 225, 225)';  // Blanc
            case 'Poison':
                return 'rgb(83, 58, 94)';  // Violet foncé
            case 'Electric':
                return 'rgb(207, 179, 20)';  // Jaune
            case 'Fairy':
                return 'rgb(223, 163, 203)';  // Rose
            case 'Fighting':
                return 'rgb(173, 114, 80)';  // Marron clair
            case 'Rock':
                return 'rgb(103, 63, 34)';  // Marron
            case 'Ice':
                return 'rgb(107, 199, 212)';  // Bleu clair
            case 'Ghost':
                return 'rgb(70, 43, 79)';  // Violet
            case 'Dragon':
                return 'rgb(187, 188, 116)';  // Jaune clair
            case 'Steel':
                return 'rgb(133, 133, 133)';  // Gris
            case 'Dark':
                return 'rgb(84, 46, 97)';  // Violet
            default:
                return 'rgb(75, 255, 195)';  // Gris par défaut
        }
    } catch (error) {
        console.error('Erreur lors du parsing du type:', error);
        return 'rgb(75, 255, 195)';  // Couleur par défaut en cas d'erreur
    }
};

export default getTypeBall;